import { render } from "./AdvertisementItem.vue?vue&type=template&id=a52fafcc"
import script from "./AdvertisementItem.vue?vue&type=script&lang=js"
export * from "./AdvertisementItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__